/**
 * Syncs performance PDP interval card radios with Skio's hidden
 * select[skio-selling-plans] so skio-plan-picker.js keeps working.
 */
(function () {
  function initPlanCards(root) {
    var containers = root.querySelectorAll(
      ".skio-performance-plan-cards[data-skio-group-id]:not([data-skio-plan-cards-init])"
    );
    containers.forEach(function (container) {
      container.setAttribute("data-skio-plan-cards-init", "1");

      var groupId = container.getAttribute("data-skio-group-id");
      if (!groupId) return;

      var groupContainer = container.closest("[skio-group-container]");
      if (!groupContainer) return;

      var select = groupContainer.querySelector(
        'select[skio-selling-plans="' + groupId + '"]'
      );
      if (!select) return;

      var radios = container.querySelectorAll(".skio-performance-plan-card__radio");
      if (!radios.length) return;

      function syncRadiosFromSelect() {
        var v = String(select.value);
        var any = false;
        radios.forEach(function (r) {
          var on = String(r.value) === v;
          r.checked = on;
          if (on) any = true;
        });
        if (!any && radios.length) {
          var first = radios[0];
          first.checked = true;
          if (String(select.value) !== String(first.value)) {
            select.value = first.value;
            select.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      }

      radios.forEach(function (radio) {
        radio.addEventListener("change", function () {
          if (!radio.checked) return;
          if (String(select.value) === String(radio.value)) return;
          select.value = radio.value;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });

      select.addEventListener("change", syncRadiosFromSelect);
      syncRadiosFromSelect();
    });
  }

  function onReady() {
    initPlanCards(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e && e.target) initPlanCards(e.target);
  });
})();
